import React from 'react';
import { Link } from 'react-router-dom';

const PublicFooter = () => {
  return (
    <footer>
      <div id="outer_main">
        <div id="outer1">
          <div id="aku11">
            <h4 className="link_heading">LOCATION</h4>
            <h4 className="ft">House No. 336, Village - Khera Khurd,<br />Delhi - 110082, India</h4>
          </div>
          <div id="aku22">
            <h4 className="link_heading">AROUND THE WEB</h4>
            <div id="social">
              <div id="contact_a_dn">
                <div className="sl sl2"><i className="fa fa-facebook-f" style={{fontSize: '16px', color: 'white', marginTop: '8px'}}></i></div>
                <div className="sl sl3"><i className="fa fa-youtube-play" style={{fontSize: '16px', color: 'white', marginTop: '8px'}}></i></div>
                <div className="sl sl5"><i className="fa fa-linkedin" style={{fontSize: '16px', color: 'white', marginTop: '8px'}}></i></div>
              </div>
            </div>
          </div>
          <div id="aku33">
            <h4 className="link_heading">CONTACT US</h4>
            <label className="ft">Phone : +91 99999 69966<br />Email: nareshmannthrowballindia@gmail.com</label>
          </div>
        </div>
      </div>
      <div id="main_link">
        <div id="main_link_inner">
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/rules">Rules</Link></li>
            <li><Link to="/events">Events</Link></li>
            <li><a href="/schedule">Schedule</a></li>
            <li><Link to="/affiliates">Affiliates</Link></li>
            <li><Link to="/photo-gallery">Gallery</Link></li>
            <li><Link to="/contact">Contact Us</Link></li>
          </ul>
          <ul>
            <li><a href="/international-recognition">International & Recognition</a></li>
            <li><a href="/international-recognition-bfa">International & Recognition BFA</a></li>
            <li><a href="/pdf/voting_rights.pdf" target="_blank">Voting Rights</a></li>
            <li><a href="/registration">Certificate of Registration</a></li>
            <li><a href="/international-participation">International Participation</a></li>
            <li><a href="/pdf/ABFI_constitution.pdf">Constitution</a></li>
            <li><Link to="/affiliates">Affiliated Units</Link></li>
            <li><a href="#">Firm Name</a></li>
            <li><a href="#">Media Coverage</a></li>
            <li><Link to="/committees">Committees</Link></li>
            <li><Link to="/accounts">Accounts</Link></li>
            <li><Link to="/rti">RTI</Link></li>
            <li><Link to="/calendar-events">Calendar Events</Link></li>
            <li><a href="/pdf/manual_baseball.pdf" target="_blank">Manuals</a></li>
            <li><a href="/history">History</a></li>
            <li><Link to="/bearer">Executive Committee</Link></li>
            <li><Link to="/website-info">Website Info</Link></li>
          </ul>
          <div className="text-center">
            <hr />
            <p style={{color: '#fff'}}>For best results use Mozilla or Chrome browsers</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default PublicFooter;